export const fastSelectStyles = {
  minWidth: '100px',
  width: '100%',
  padding: '16px 12px',
  fontSize: '14px',
  border: '1px solid #c4c4c4',
  borderRadius: '4px',
  backgroundColor: '#f5f5f5',
  outline: 'none',
  cursor: 'pointer',
};

export const fastLabelStyles = {
  display: 'block',
  marginBottom: '8px',
  fontSize: '12px',
  color: '#666',
  fontWeight: 500,
};

export const fastErrorStyles = {
  marginTop: '4px',
  fontSize: '12px',
  color: '#d32f2f',
};
